export const TOUR_SETTINGS_SAVE_SUCCESS_MESSAGE = 'Your tour setting changes were saved';
export const TOUR_DURATION_SAVE_SUCCESS_MESSAGE = 'Tour length updated';
export const TOUR_DURATION_SAVE_ERROR_MESSAGE = 'Tour length couldn’t be updated. Try again.';
